import { StyledGraph, StyledPartialPeriod } from './Graph.style';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import useGraph from './useGraph';
import { RESOURCE_TYPES } from '../../resource_types';
import GraphEmptyState from '../../EmptyState/GraphEmptyState';
import PartialIndicator from '../PartialIndicator';

const Graph = ({
  data,
  resourceType,
  granularity,
  graphView,
  epicsPercent
}) => {
  const { graphOptions, isPartialCategoryExists } = useGraph({
    data,
    resourceType,
    granularity,
    graphView
  });

  const shouldShowEpicsHeader =
    resourceType.key === RESOURCE_TYPES.JIRA_EPICS.key;
  const PercentsWithoutEpics = 100 - epicsPercent;

  const isEmptyState = data?.length === 0;

  if (isEmptyState) return <GraphEmptyState />;

  return (
    <StyledGraph>
      <header>
        Showing top {resourceType.name} - <b>Click chart for details</b>.<br />{' '}
        {shouldShowEpicsHeader && (
          <div>
            Showing all issues linked to epics, Note:{' '}
            <b>{PercentsWithoutEpics}%</b> of your issues are not linked to
            epics!
          </div>
        )}
        {isPartialCategoryExists && (
          <StyledPartialPeriod>
            <PartialIndicator /> Partial period
          </StyledPartialPeriod>
        )}
      </header>
      <main>
        <HighchartsReact
          containerProps={{ style: { height: '100%', width: '100%' } }}
          highcharts={Highcharts}
          options={graphOptions}
        />
      </main>
    </StyledGraph>
  );
};

export default Graph;
